export const R = {
	"Name1": "this is my long string",
	"Bitmap1": "[base64 mime encoded serialized .NET Framework object]",
	"Icon1": "[base64 mime encoded string representing a byte array form of the .NET Framework object]",
	"CaregiverRoleEnum_AllergyDoctor": "Lægen",
	"CaregiverRoleEnum_Dentist": "Tandlægen",
	"CaregiverRoleEnum_Dermatologist": "Hudlægen",
	"CaregiverRoleEnum_Doctor": "Familielægen",
	"CaregiverRoleEnum_Midwife": "Jordemoderen",
	"CaregiverRoleEnum_Nurse": "Sundhedsplejersken",
	"CaregiverRoleEnum_Physiotherapist": "Fysioterapeuten",
	"CaregiverRoleEnum_Psychologist": "Psykologen",
	"CaregiverRoleEnum_Rheumatologist": "Reumatologen",
	"CaregiverRoleEnum_SundVaegtDoctor": "SundVægt-lægen",
	"CaregiverRoleEnum_SundVaegtNurse": "SundVægt-sygeplejersken",
	"CaregiverRoleEnum_Dietitian": "Diætisten",
	"CaregiverRoleEnum_AcneDermatologist": "Hudlægen",
	"CaregiverRoleEnum_Veterinarian": "Dyrlægen",
	"CaregiverRoleEnum_AllergyDoctor_Indefinite": "Læge",
	"CaregiverRoleEnum_Dentist_Indefinite": "Tandlæge",
	"CaregiverRoleEnum_Dermatologist_Indefinite": "Hudlæge",
	"CaregiverRoleEnum_Doctor_Indefinite": "Familielæge",
	"CaregiverRoleEnum_Midwife_Indefinite": "Jordemoder",
	"CaregiverRoleEnum_Nurse_Indefinite": "Sundhedsplejerske",
	"CaregiverRoleEnum_Physiotherapist_Indefinite": "Fysioterapeut",
	"CaregiverRoleEnum_Psychologist_Indefinite": "Psykolog",
	"CaregiverRoleEnum_Rheumatologist_Indefinite": "Reumatolog",
	"CaregiverRoleEnum_SundVaegtDoctor_Indefinite": "SundVægt-læge",
	"CaregiverRoleEnum_SundVaegtNurse_Indefinite": "SundVægt-sygeplejerske",
	"CaregiverRoleEnum_Dietitian_Indefinite": "Diætist",
	"CaregiverRoleEnum_AcneDermatologist_Indefinite": "Hudlæge",
	"CaregiverRoleEnum_Veterinarian_Indefinite": "Dyrlæge",
	"ConsultationPaymentProviderEnum_ApplePay": "App Store",
	"ConsultationPaymentProviderEnum_Company": "Virksomhed",
	"ConsultationPaymentProviderEnum_Coupon": "Kupon",
	"ConsultationPaymentProviderEnum_DIBS": "Enkeltkonsultation",
	"ConsultationPaymentProviderEnum_ePay": "Enkeltkonsultation",
	"ConsultationPaymentProviderEnum_GoogleWallet": "Google Play",
	"ConsultationPaymentProviderEnum_GracePeriod": "Gratis svar",
	"ConsultationPaymentProviderEnum_ReepayCheckout": "Enkeltkonsultation",
	"ConsultationPaymentProviderEnum_Repay": "Enkeltkonsultation",
	"ConsultationPaymentProviderEnum_Subscription": "Abonnement",
	"ConsultationPaymentProviderEnum_PriceOverride": "-",
	"ConsultationTypeEnum_AllergyCheckVideo": "Allergitjek",
	"ConsultationTypeEnum_DentistMessage": "Tekstkonsultation - tandlæge",
	"ConsultationTypeEnum_DentistVideo": "Videokonsultation - tandlæge",
	"ConsultationTypeEnum_DermatologistMessage": "Tekstkonsultation - hudlæge",
	"ConsultationTypeEnum_DermatologistVideo": "Videokonsultation - hudlæge",
	"ConsultationTypeEnum_Message": "Tekstkonsultation - læge",
	"ConsultationTypeEnum_MidwifeMessage": "Tekstkonsultation - jordemoder",
	"ConsultationTypeEnum_MidwifeVideo": "Videokonsultation - jordemoder",
	"ConsultationTypeEnum_NurseMessage": "Tekstkonsultation - sundhedsplejerske",
	"ConsultationTypeEnum_NurseVideo": "Videokonsultation - sundhedsplejerske",
	"ConsultationTypeEnum_PhysiotherapistStartupVideo": "Videokonsultation - fysioterapeut opstart",
	"ConsultationTypeEnum_PhysiotherapistMessage": "Tekstkonsultation - fysioterapeut",
	"ConsultationTypeEnum_Prescription": "Receptfornyelse",
	"ConsultationTypeEnum_PsychologistVideo": "Videokonsultation - psykolog",
	"ConsultationTypeEnum_PsychologistCrisisVideo": "Videokonsultation - krisepsykolog",
	"ConsultationTypeEnum_RheumatologistVideo": "Videokonsultation - reumatolog",
	"ConsultationTypeEnum_SundVaegtStartupMessage": "SundVægt opstart",
	"ConsultationTypeEnum_SundVaegtNurseCheckupVideo": "SundVægt kontrol",
	"ConsultationTypeEnum_Video": "Videokonsultation - læge",
	"ConsultationTypeEnum_DietitianStartupVideo": "Videokonsultation - diætist opstart",
	"PlanInterval_Day": "Daglig",
	"PlanInterval_Month": "Månedlig",
	"PlanInterval_Week": "Ugentlig",
	"PlanInterval_Year": "Årlig",
	"ServiceTypeEnum_AllergyCheck": "Allergitjek: Videokonsultatation",
	"ServiceTypeEnum_DermatologistMessage": "Hudlæge: Tekstkonsultation",
	"ServiceTypeEnum_DermatologistMessageReply": "Hudlæge: Svar på tekstkonsultation",
	"ServiceTypeEnum_DermatologistVideo": "Hudlæge: Videokonsultation",
	"ServiceTypeEnum_Message": "Læge: Tekstkonsultation",
	"ServiceTypeEnum_MessageReply": "Læge: Svar på tekstkonsultation",
	"ServiceTypeEnum_PhysiotherapistStartupVideo": "Fysioterapeut: Videokonsultation opstart",
	"ServiceTypeEnum_PhysiotherapistMessage": "Fysioterapeut: Tekstkonsultation",
	"ServiceTypeEnum_PhysiotherapistMessageReply": "Fysioterapeut: Svar på tekstkonsultation",
	"ServiceTypeEnum_Prescription": "Læge: Receptfornyelse",
	"ServiceTypeEnum_PsychologistVideo": "Psykolog: Videokonsultation",
	"ServiceTypeEnum_PsychologistCrisisVideo": "Krisepsykolog: Videokonsultation",
	"ServiceTypeEnum_RheumatologistVideo": "Reumatolog: Videokonsultation",
	"ServiceTypeEnum_SundVaegtStartupMessage": "SundVægt opstart",
	"ServiceTypeEnum_VideoConsultation": "Læge: Videokonsultatation",
	"ServiceTypeEnum_AllergyCheckVideo": "Allergitjek",
	"ServiceTypeEnum_DietitianStartupVideo": "Diætist: Videokonsultation opstart",
	"UserTypeEnum_Admin": "Administrator",
	"UserTypeEnum_Doctor": "Behandler",
	"UserTypeEnum_Patient": "Patient",
	"ConsultationTypeEnum_SundVaegtDoctorCheckupVideo": "SundVægt-læge: Videokonsultation",
	"ServiceTypeEnum_SundVaegtDoctorCheckupVideo": "SundVægt-læge: Videokonsultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupVideo": "SundVægt-sygeplejerske: Videokontrol",
	"ConsultationTypeEnum_SundVaegtNurseCheckupMessage": "SundVægt-sygeplejerske: Tekstkonsultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessage": "SundVægt-sygeplejerske: Tekstkonsultation",
	"ServiceTypeEnum_SundVaegtNurseCheckupMessageReply": "SundVægt-sygeplejerske: Svar på tekstkonsultation",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessageReply": "SundVægt spørgeskema: Svar",
	"ConsultationTypeEnum_SundVaegtNurseAdHocVideo": "SundVægt kontrol",
	"ServiceTypeEnum_SundVaegtNurseAdHocVideo": "SundVægt-sygeplejerske: Videokonsultation",
	"ConsultationTypeEnum_SundVaegtQuestionnaireMessage": "SundVægt spørgeskema",
	"ServiceTypeEnum_SundVaegtQuestionnaireMessage": "SundVægt spørgeskema",
	"ConsultationTypeEnum_PhysiotherapistCheckupVideo": "Videokonsultation - fysioterapeut",
	"ServiceTypeEnum_PhysiotherapistCheckupVideo": "Fysioterapeut: Videokonsultation",
	"ConsultationTypeEnum_PhysiotherapistQuestionnaireMessage": "Fysioterapeut spørgeskema",
	"ServiceTypeEnum_PhysiotherapistQuestionnaireMessage": "Fysioterapeut: spørgeskema",
	"ServiceTypeEnum_SundVaegtStartupMessageReply": "SundVægt opstart: Svar",
	"SubscriptionStatusEnum_Active": "Aktiv",
	"SubscriptionStatusEnum_Canceled": "Afmeldt",
	"SubscriptionStatusEnum_Expired": "Udløbet",
	"SubscriptionStatusEnum_PastDue": "Forfalden",
	"SubscriptionStatusEnum_Trialing": "Gratis prøve",
	"SubscriptionStatusEnum_Unknown": "Ukendt",
	"ConsultationTypeEnum_DietitianCheckupVideo": "Videokonsultation - diætist opfølgning",
	"ServiceTypeEnum_DietitianCheckupVideo": "Diætist: Videokonsultation opfølgning",
	"ConsultationTypeEnum_DietitianUploadAttachmentMessage": "Upload bilag konsultation - diætist",
	"ServiceTypeEnum_DietitianUploadAttachmentMessage": "Diætist: Upload bilag konsultation",
	"ServiceTypeEnum_DietitianVideo": "Diætist: Videokonsultation",
	"AllergyCheckVideo": "Allergitjek",
	"ConsultationTypeEnum_AllergyCheck": "Allergitjek",
	"ConsultationTypeEnum_PersonalHealthProgrammeStartup": "Opstart af personligt sundhedsprogram",
	"ServiceTypeEnum_PersonalHealthProgrammeStartup": "Opstart af personligt sundhedsprogram",
	"ConsultationTypeEnum_AcneProgrammeStartupMessage": "Akneforløb opstart",
	"ConsultationTypeEnum_AcneProgrammeStartupVideo": "Akneforløb video opstart",
	"ConsultationTypeEnum_AcneProgrammeCheckupVideo": "Akneforløb video opfølgning",
	"ServiceTypeEnum_AcneProgrammeStartupMessage": "Akneforløb opstart",
	"ServiceTypeEnum_AcneProgrammeStartupVideo": "Akneforløb video opstart",
	"ServiceTypeEnum_AcneProgrammeCheckupVideo": "Akneforløb video opfølgning",
	"ConsultationTypeEnum_AcneDermatologistMessage": "Tekstkonsultation - hudlæge",
	"ServiceTypeEnum_AcneDermatologistMessage": "Hudlæge: Tekstkonsultation",
	"ServiceTypeEnum_AcneDermatologistMessageReply": "Hudlæge: Svar på tekstkonsultation",
	"ServiceTypeEnum_VeterinarianVideo": "Dyrlæge: Videokonsultation",
	"ConsultationPaymentProviderEnum_Free": "Gratis",
	"ConsultationTypeEnum_VeterinarianVideo": "Videokonsultation – dyrlæge",
	"PetSex_Female": "Hun",
	"PetSex_FemaleSterilized": "Steriliseret hun",
	"PetSex_Male": "Han",
	"PetSex_MaleNeutered": "Kastreret han",
	"PetSex_Unknown": "Ukendt",
	"PetType_Dog": "Hund",
	"PetType_Cat": "Kat",
	"PetType_Rabbit": "Kanin",
	"PetType_Rodent": "Gnaver",
	"VetConsultationReasonEnum_Gastrointestinal": "Gastrointestinal",
	"VetConsultationReasonEnum_SkinCoatEars": "Hud, pels og ører (herunder også sår og analkirtler)",
	"VetConsultationReasonEnum_Poisoning": "Forgiftning",
	"VetConsultationReasonEnum_Eyes": "Øjne",
	"VetConsultationReasonEnum_UrinaryTract": "Urinveje",
	"VetConsultationReasonEnum_Lameness": "Halthed",
	"VetConsultationReasonEnum_RespiratoryTract": "Luftveje",
	"VetConsultationReasonEnum_OralCavity": "Mundhule og tænder",
	"VetConsultationReasonEnum_Pain": "Smerter/feber/nedstemthed",
	"VetConsultationReasonEnum_Claws": "Kløer",
	"VetConsultationReasonEnum_GenitalsMammaryGlands": "Genitalier og mammae",
	"VetConsultationReasonEnum_ReproductionCycle": "Reproduktion og cyklus",
	"VetConsultationReasonEnum_Behaviour": "Adfærd",
	"VetConsultationReasonEnum_Prescription": "Recept",
	"VetConsultationReasonEnum_OtherReason": "Andet",
	"VetConsultationOutcomeEnum_AdvisedForHomeTreatment": "Rådgivet til behandling i hjemmet (Herunder også cases der ikke kræver behandling)",
	"VetConsultationOutcomeEnum_ReferredDuringRegularOpeningHours": "Henvist inden for almindelig åbningstid",
	"VetConsultationOutcomeEnum_ReferredOutsideRegularOpeningHours": "Henvist uden for almindelig åbningstid"
}